export default function WarningsCallout({ warnings }) {
  if (!warnings?.length) return null;

  return (
    <div className="mt-3 rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-yellow-800">
        Notes
      </p>
      <ul className="mt-1 space-y-1">
        {warnings.map((warning, index) => (
          <li key={index} className="text-xs text-yellow-700">
            {warning}
          </li>
        ))}
      </ul>
    </div>
  );
}
